<template>
  <div>
    <v-layout row>
      <v-flex grow>
        <h2 class="headline pb-3">Payment Info</h2>
      </v-flex>
      <v-flex shrink>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn flat icon color="primary" @click.stop="saveInfo()" v-on="on">
              <v-icon class="mr-1">save</v-icon>
            </v-btn>
          </template>
          <span>Save payment information</span>
        </v-tooltip>
        <v-menu v-if="$vuetify.breakpoint.mdAndUp">
          <template v-slot:activator="{ on }">
            <v-btn flat icon color="primary" v-on="on">
              <v-icon>more_horiz</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile>
              <v-list-tile-title @click.stop="deleteDialog = true">
                Delete Lease
              </v-list-tile-title>
            </v-list-tile>
            <v-layout row justify-center>
              <v-dialog v-model="deleteDialog" max-width="600" persistent>
                <v-card>
                  <v-card-title class="headline grey lighten-3" primary-title>
                    Delete Lease
                  </v-card-title>
                  <v-card-text>
                    <p class="subheading">Are you sure you wish to delete this lease? This action cannot be reverted.</p>
                    <v-checkbox
                      v-model="deleteConfirmed"
                      label="I understand that this action cannot be reverted"
                    ></v-checkbox>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="deleteDialog = false">Cancel</v-btn>
                    <v-btn
                      color="error"
                      :disabled="!deleteConfirmed"
                      @click.stop="deleteHandler()"
                    >
                      <v-icon>delete</v-icon>
                      Delete
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
    <LeaseInfo ref="info" :lease.sync="lease" />
    <!-- <LeaseNotice /> -->

  </div>
</template>
<script>
import { mapActions } from 'vuex'
import LeaseInfo from '@/components/houselist/details/LeaseInfo'

export default {
  name: 'DetailsLease',
  components: { LeaseInfo },
  data() {
    return {
      deleteDialog: false,
      deleteConfirmed: false
    }
  },
  computed: {
    message() {

      return `
Dear ${this.contact.name}:
<br/>
  According to the payment record the kank sent us, we noticed that you have not pay the rent from ${this.details.from}.
  By the end of ${this.details.to}, you have been owned us an amount of ${this.details.amount}.
<br/>
  Please pay it before ${this.details.payBefore} or we will commit your case to tenant service and start a formal complaint.
<br/>
Your tenant agant,
Unity Property Management
      `;
    },

    lease() {
      let lease = this.$store.getters['HouseList/Lease/getLease']
      if (lease.mgmt_fee_type == 2) {
        lease.mgmt_fee_rate = lease.mgmt_fee_fixed
      }
      return lease
    }
  },
  methods: {
    ...mapActions({
      updateLease: 'HouseList/Lease/updateLease',
      deleteLease: 'HouseList/Lease/deleteLease',
    }),
    saveInfo() {
      if (this.$refs.info.$refs.addLease.validate()) {
        // console.log('this.lease', this.lease)
        if (this.lease.mgmt_fee_type === 2) {
          this.lease.mgmt_fee_fixed = this.lease.mgmt_fee_rate
        } else {
          this.lease.mgmt_fee_fixed = ''
        }

        this.updateLease(this.lease)
      }
    },
    async deleteHandler() {
      await this.deleteLease(this.$route.params.id)
      this.$router.push({path: `/houses/${this.$route.params.houseId}`})
    }
  }
}
</script>
